import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSubSubcategoryProducts } from "../../redux/actions/subsubcategory";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import ProductCard from "../../components/Cards/ProductCard";
import Breadc from "./bread.jsx";
import { FiChevronDown, FiChevronUp, FiRotateCw } from "react-icons/fi";
import "./SsubListPage.scss";

const SsubListPage = () => {
  const { subSubCategoryId } = useParams();
  const dispatch = useDispatch();

  const productsState = useSelector((state) => state.subsubcategories);
  const { products = [], error } = productsState;
  const { subsubcategories = [] } = useSelector(
    (state) => state.subsubcategories
  );
  const { subcategories = [] } = useSelector((state) => state.subcategories);
  const { filters = [] } = useSelector((state) => state.filters);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [pendingRangeValues, setPendingRangeValues] = useState({});
  const [activeFilters, setActiveFilters] = useState([]);
  const [initialRangeValues, setInitialRangeValues] = useState({});
  const [expandedFilters, setExpandedFilters] = useState([]);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const openFilters = () => setShowMobileFilters(true);
  const closeFilters = () => setShowMobileFilters(false);
  const [visibleCount, setVisibleCount] = useState(24);
  const [sortOption, setSortOption] = useState("none");
  const [discountOnly, setDiscountOnly] = useState(false);

  const [initialPriceRange, setInitialPriceRange] = useState({
    min: 0,
    max: 0,
  });
  const [pendingPriceRange, setPendingPriceRange] = useState({
    min: 0,
    max: 0,
  });
  const [priceRangeFilter, setPriceRangeFilter] = useState(null);

  useEffect(() => {
    if (subSubCategoryId) {
      dispatch(getSubSubcategoryProducts(subSubCategoryId));
    }
  }, [subSubCategoryId, dispatch]);
  const currentSubSubcat = subsubcategories.find(
    (ssc) => ssc._id === subSubCategoryId
  );

  let parentSubCatId = null;
  if (
    currentSubSubcat &&
    Array.isArray(currentSubSubcat.parentSubcategories) &&
    currentSubSubcat.parentSubcategories.length > 0
  ) {
    parentSubCatId = currentSubSubcat.parentSubcategories[0]._id;
  }

  const currentSubcat = subcategories.find((sc) => sc._id === parentSubCatId);

  let parentCatId = null;
  if (
    currentSubcat &&
    Array.isArray(currentSubcat.parentCategories) &&
    currentSubcat.parentCategories.length > 0
  ) {
    parentCatId = currentSubcat.parentCategories[0]._id;
  }

  const breadData = {
    category: parentCatId ? [parentCatId] : [],
    subcategory: parentSubCatId ? [parentSubCatId] : [],
    subsubcategory: [subSubCategoryId],
  };

  useEffect(() => {
    if (!filters || filters.length === 0) return;

    if (!subSubCategoryId) {
      setActiveFilters(filters);
      return;
    }

    const subSubCatArr = subSubCategoryId.split(",").map((id) => id.trim());
    const applicableFilters = filters.filter(
      (f) =>
        Array.isArray(f.subsubcategoryId) &&
        f.subsubcategoryId.some((obj) =>
          subSubCatArr.includes(obj._id.toString())
        )
    );
    setActiveFilters(
      applicableFilters.length > 0 ? applicableFilters : filters
    );
  }, [filters, subSubCategoryId]);

  useEffect(() => {
    if (activeFilters.length > 0) {
      const newSelectedFilters = { ...selectedFilters };
      const newPending = { ...pendingRangeValues };
      const newInitialValues = { ...initialRangeValues };

      activeFilters.forEach((filter) => {
        if (
          filter.isRange &&
          filter.range &&
          typeof filter.range.min === "number" &&
          typeof filter.range.max === "number"
        ) {
          if (!newSelectedFilters[filter._id]) {
            newSelectedFilters[filter._id] = {
              min: filter.range.min,
              max: filter.range.max,
            };
          }
          if (!newPending[filter._id]) {
            newPending[filter._id] = {
              min: filter.range.min,
              max: filter.range.max,
            };
          }
          if (!newInitialValues[filter._id]) {
            newInitialValues[filter._id] = {
              min: filter.range.min,
              max: filter.range.max,
            };
          }
        } else if (!filter.isRange) {
          if (!newSelectedFilters[filter._id]) {
            newSelectedFilters[filter._id] = [];
          }
        }
      });

      setSelectedFilters(newSelectedFilters);
      setPendingRangeValues(newPending);
      setInitialRangeValues(newInitialValues);
    }
    // eslint-disable-next-line
  }, [activeFilters]);

  useEffect(() => {
    if (activeFilters.length > 0) {
      const allFilterIds = activeFilters.map((f) => f._id);
      setExpandedFilters(allFilterIds);
    }
  }, [activeFilters]);

  useEffect(() => {
    if (products && products.length > 0) {
      const maxPrice = Math.max(
        ...products.map((p) => Number(p.originalPrice) || 0)
      );
      setInitialPriceRange({ min: 0, max: maxPrice });
      setPendingPriceRange({ min: 0, max: maxPrice });
      setPriceRangeFilter({ min: 0, max: maxPrice });
    }
  }, [products]);

  const handlePricePendingChange = (e, rangeType) => {
    const value = Number(e.target.value);
    setPendingPriceRange((prev) => ({ ...prev, [rangeType]: value }));
  };
  const handlePriceTextChange = (e, rangeType) => {
    let val = Number(e.target.value);
    if (val < initialPriceRange.min) val = initialPriceRange.min;
    if (val > initialPriceRange.max) val = initialPriceRange.max;
    setPendingPriceRange((prev) => ({ ...prev, [rangeType]: val }));
  };
  const applyPriceRangeFilter = () => {
    setPriceRangeFilter({ ...pendingPriceRange });
  };

  const handlePendingRangeChange = (e, rangeType, filterId) => {
    const value = Number(e.target.value);
    setPendingRangeValues((prev) => ({
      ...prev,
      [filterId]: {
        ...prev[filterId],
        [rangeType]: value,
      },
    }));
  };

  const handleTextPendingRangeChange = (e, rangeType, filterId, rangeObj) => {
    let val = Number(e.target.value);
    if (val < rangeObj.min) val = rangeObj.min;
    if (val > rangeObj.max) val = rangeObj.max;

    setPendingRangeValues((prev) => ({
      ...prev,
      [filterId]: {
        ...prev[filterId],
        [rangeType]: val,
      },
    }));
  };

  const applyRange = (filterId) => {
    const { min, max } = pendingRangeValues[filterId];
    setSelectedFilters((prev) => ({
      ...prev,
      [filterId]: { min, max },
    }));
  };

  const handleCheckboxChange = (e, filterId) => {
    const { value, checked } = e.target;
    setSelectedFilters((prev) => {
      const currentVals = Array.isArray(prev[filterId]) ? prev[filterId] : [];
      let updated;
      if (checked) {
        updated = [...currentVals, value];
      } else {
        updated = currentVals.filter((v) => v !== value);
      }
      return {
        ...prev,
        [filterId]: updated,
      };
    });
  };

  const handleToggleFilter = (filterId) => {
    setExpandedFilters((prev) => {
      if (prev.includes(filterId)) {
        return prev.filter((id) => id !== filterId);
      } else {
        return [...prev, filterId];
      }
    });
  };

  useEffect(() => {
    if (!products) return;
    let filtered = products;

    activeFilters.forEach((filter) => {
      const filterId = filter._id;
      if (
        filter.isRange &&
        filter.range &&
        typeof filter.range.min === "number" &&
        typeof filter.range.max === "number"
      ) {
        const currentMin = selectedFilters[filterId]?.min;
        const currentMax = selectedFilters[filterId]?.max;
        const initMin = initialRangeValues[filterId]?.min;
        const initMax = initialRangeValues[filterId]?.max;

        const userChanged =
          typeof currentMin === "number" &&
          typeof currentMax === "number" &&
          (currentMin !== initMin || currentMax !== initMax);

        if (userChanged) {
          filtered = filtered.filter((p) => {
            const feat = p.features[filterId];
            let featNum;
            if (feat && typeof feat === "object" && feat.value !== undefined) {
              featNum = Number(feat.value);
            } else {
              featNum = Number(feat);
            }
            return (
              !isNaN(featNum) && featNum >= currentMin && featNum <= currentMax
            );
          });
        }
      } else if (!filter.isRange) {
        const selectedVals = selectedFilters[filterId] || [];
        if (Array.isArray(selectedVals) && selectedVals.length > 0) {
          filtered = filtered.filter((p) => {
            const featVal = p.features[filterId];
            if (Array.isArray(featVal)) {
              return featVal.some((val) => selectedVals.includes(val));
            } else if (
              featVal &&
              typeof featVal === "object" &&
              featVal.value !== undefined
            ) {
              return selectedVals.includes(String(featVal.value));
            } else {
              return selectedVals.includes(String(featVal));
            }
          });
        }
      }
    });

    if (priceRangeFilter) {
      const { min, max } = priceRangeFilter;
      filtered = filtered.filter((p) => {
        const price = Number(p.originalPrice) || 0;
        return price >= min && price <= max;
      });
    }

    if (discountOnly) {
      filtered = filtered.filter((product) => {
        return product.discountPrice && Number(product.discountPrice) > 0;
      });
    }

    switch (sortOption) {
      case "price-asc":
        filtered.sort(
          (a, b) => Number(a.originalPrice) - Number(b.originalPrice)
        );
        break;
      case "price-desc":
        filtered.sort(
          (a, b) => Number(b.originalPrice) - Number(a.originalPrice)
        );
        break;
      case "name-asc":
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "name-desc":
        filtered.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "none":
      default:
        break;
    }

    setFilteredProducts(filtered);
  }, [
    products,
    selectedFilters,
    activeFilters,
    initialRangeValues,
    priceRangeFilter,
    sortOption,
    discountOnly,
  ]);

  if (error) {
    return <div>Помилка: {error}</div>;
  }

  return (
    <div>
      <Header />

      <div className="bread">
        <Breadc data={breadData} />
      </div>

      <div className="sort-and-discount-panel">
        <div className="sort-control">
          <label htmlFor="sort">Сортування:</label>
          <select
            id="sort"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
          >
            <option value="none">Без сортування</option>
            <option value="price-asc">Ціна за зростанням</option>
            <option value="price-desc">Ціна за спаданням</option>
            <option value="name-asc">Назва А–Я</option>
            <option value="name-desc">Назва Я–А</option>
          </select>
        </div>

        <div className="discount-filter">
          <label>
            <input
              type="checkbox"
              checked={discountOnly}
              onChange={() => setDiscountOnly(!discountOnly)}
            />
            Тільки зі знижкою
          </label>
        </div>
      </div>

      <div className="flls">
        <button className="show-filters-button" onClick={openFilters}>
          Показати фільтри
        </button>

        <div className="sort-and-discount-panelss">
          <div className="sort-controlss">
            <label htmlFor="sort"></label>
            <select
              id="sort"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="none">Без сортування</option>
              <option value="price-asc">Ціна за зростанням</option>
              <option value="price-desc">Ціна за спаданням</option>
              <option value="name-asc">Назва А–Я</option>
              <option value="name-desc">Назва Я–А</option>
            </select>
          </div>

          <div className="discount-filterss">
            <label>
              <input
                type="checkbox"
                checked={discountOnly}
                onChange={() => setDiscountOnly(!discountOnly)}
              />
              Тільки зі знижкою
            </label>
          </div>
        </div>
      </div>

      <div className="products-page">
        <div className="products-page__filters">
          <h2>Фільтри:</h2>

          <div className="filter-item">
            <div className="filter-header">
              <span>Ціна:</span>
            </div>
            <div className="range-section">
              <div className="range-header">
                <label>
                  <input
                    type="number"
                    value={pendingPriceRange.min}
                    onChange={(e) => handlePriceTextChange(e, "min")}
                  />
                </label>
                <label>
                  <input
                    type="number"
                    value={pendingPriceRange.max}
                    onChange={(e) => handlePriceTextChange(e, "max")}
                  />
                </label>
              </div>

              <div className="range-input-wrapper">
                <input
                  type="range"
                  min={initialPriceRange.min}
                  max={initialPriceRange.max}
                  value={pendingPriceRange.min}
                  onChange={(e) => handlePricePendingChange(e, "min")}
                  className="range-input"
                />
                <input
                  type="range"
                  min={initialPriceRange.min}
                  max={initialPriceRange.max}
                  value={pendingPriceRange.max}
                  onChange={(e) => handlePricePendingChange(e, "max")}
                  className="range-input"
                />
                <div className="range-track-base" />
                <div
                  className="range-track-active"
                  style={{
                    left: `${
                      Math.min(pendingPriceRange.min, pendingPriceRange.max) /
                      (initialPriceRange.max / 100)
                    }%`,
                    width: `${
                      ((Math.max(pendingPriceRange.min, pendingPriceRange.max) -
                        Math.min(
                          pendingPriceRange.min,
                          pendingPriceRange.max
                        )) /
                        (initialPriceRange.max / 100)) *
                      1
                    }%`,
                  }}
                ></div>
              </div>

              <button className="accept" onClick={applyPriceRangeFilter}>
                Ок
              </button>
              <p className="range-hint">
                *Фільтрація за оригінальною ціною без урахування знижки.
              </p>
            </div>
          </div>

          {activeFilters.map((filter) => {
            const isExpanded = expandedFilters.includes(filter._id);
            return (
              <div key={filter._id} className="filter-item">
                <div
                  className="filter-header"
                  onClick={() => handleToggleFilter(filter._id)}
                >
                  <span>{filter.displayName}:</span>
                  {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                </div>

                {isExpanded && (
                  <>
                    {filter.isRange && filter.range ? (
                      <div className="range-section">
                        <div className="range-header">
                          <label>
                            <input
                              type="number"
                              value={
                                pendingRangeValues[filter._id]?.min ??
                                filter.range.min
                              }
                              onChange={(e) =>
                                handleTextPendingRangeChange(
                                  e,
                                  "min",
                                  filter._id,
                                  filter.range
                                )
                              }
                            />
                          </label>
                          <label>
                            <input
                              type="number"
                              value={
                                pendingRangeValues[filter._id]?.max ??
                                filter.range.max
                              }
                              onChange={(e) =>
                                handleTextPendingRangeChange(
                                  e,
                                  "max",
                                  filter._id,
                                  filter.range
                                )
                              }
                            />
                          </label>
                        </div>

                        <div className="range-input-wrapper">
                          <input
                            type="range"
                            min={filter.range.min}
                            max={filter.range.max}
                            value={
                              pendingRangeValues[filter._id]?.min ||
                              filter.range.min
                            }
                            onChange={(e) =>
                              handlePendingRangeChange(e, "min", filter._id)
                            }
                            className="range-input"
                          />
                          <input
                            type="range"
                            min={filter.range.min}
                            max={filter.range.max}
                            value={
                              pendingRangeValues[filter._id]?.max ||
                              filter.range.max
                            }
                            onChange={(e) =>
                              handlePendingRangeChange(e, "max", filter._id)
                            }
                            className="range-input"
                          />

                          <div className="range-track-base"></div>
                          <div
                            className="range-track-active"
                            style={{
                              left: `${
                                Math.min(
                                  pendingRangeValues[filter._id]?.min ??
                                    filter.range.min,
                                  pendingRangeValues[filter._id]?.max ??
                                    filter.range.max
                                ) /
                                (filter.range.max / 100)
                              }%`,
                              width: `${
                                ((Math.max(
                                  pendingRangeValues[filter._id]?.min ??
                                    filter.range.min,
                                  pendingRangeValues[filter._id]?.max ??
                                    filter.range.max
                                ) -
                                  Math.min(
                                    pendingRangeValues[filter._id]?.min ??
                                      filter.range.min,
                                    pendingRangeValues[filter._id]?.max ??
                                      filter.range.max
                                  )) /
                                  (filter.range.max / 100)) *
                                1
                              }%`,
                            }}
                          ></div>
                        </div>

                        <button
                          className="accept"
                          onClick={() => applyRange(filter._id)}
                        >
                          Ок
                        </button>
                        <p className="range-hint">
                          *Фільтр за діапазоном набуде чинності після натискання
                          "OK".
                        </p>
                      </div>
                    ) : (
                      <div>
                        {filter.values?.map((valObj) => (
                          <label key={valObj._id} className="checkbox">
                            <input
                              type="checkbox"
                              name={filter._id}
                              value={valObj._id}
                              checked={
                                selectedFilters[filter._id]?.includes(
                                  valObj._id
                                ) || false
                              }
                              onChange={(e) =>
                                handleCheckboxChange(e, filter._id)
                              }
                            />
                            <span className="checkbox-custom"></span>
                            <span className="checkbox-label">
                              {valObj.value}
                            </span>
                          </label>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>

        <div className="products-page__products">
          <div className="products-grid">
            {filteredProducts.slice(0, visibleCount).map((prod) => (
              <ProductCard data={prod} key={prod._id} />
            ))}
            {visibleCount < filteredProducts.length && (
              <div
                className="load-more-container"
                onClick={() => setVisibleCount((prev) => prev + 24)}
              >
                <FiRotateCw className="load-more-icon" />
                <button className="load-more-button">
                  Показати ще 24 продукти
                </button>
              </div>
            )}
            {filteredProducts.length === 0 && (
              <h1 className="no-products">Продукти не знайдені!</h1>
            )}
          </div>
        </div>

        {showMobileFilters && (
          <div className="mobile-filters-overlay">
            <div className="mobile-filters-content">
              <button className="close-filters-button" onClick={closeFilters}>
                Закрити
              </button>

              <h2 className="filters-button">Фільтри:</h2>

              <div className="filter-item">
                <div className="filter-header">
                  <span>Ціна (originalPrice):</span>
                </div>
                <div className="range-section">
                  <div className="range-header">
                    <label>
                      <input
                        type="number"
                        value={pendingPriceRange.min}
                        onChange={(e) => handlePriceTextChange(e, "min")}
                      />
                    </label>
                    <label>
                      <input
                        type="number"
                        value={pendingPriceRange.max}
                        onChange={(e) => handlePriceTextChange(e, "max")}
                      />
                    </label>
                  </div>

                  <div className="range-input-wrapper">
                    <input
                      type="range"
                      min={initialPriceRange.min}
                      max={initialPriceRange.max}
                      value={pendingPriceRange.min}
                      onChange={(e) => handlePricePendingChange(e, "min")}
                      className="range-input"
                    />
                    <input
                      type="range"
                      min={initialPriceRange.min}
                      max={initialPriceRange.max}
                      value={pendingPriceRange.max}
                      onChange={(e) => handlePricePendingChange(e, "max")}
                      className="range-input"
                    />

                    <div className="range-track-base" />
                    <div
                      className="range-track-active"
                      style={{
                        left: `${
                          Math.min(
                            pendingPriceRange.min,
                            pendingPriceRange.max
                          ) /
                          (initialPriceRange.max / 100)
                        }%`,
                        width: `${
                          ((Math.max(
                            pendingPriceRange.min,
                            pendingPriceRange.max
                          ) -
                            Math.min(
                              pendingPriceRange.min,
                              pendingPriceRange.max
                            )) /
                            (initialPriceRange.max / 100)) *
                          1
                        }%`,
                      }}
                    ></div>
                  </div>

                  <button className="accept" onClick={applyPriceRangeFilter}>
                    Ок
                  </button>
                  <p className="range-hint">
                    *Фільтр за ціною набуде чинності після натискання "OK".
                  </p>
                </div>
              </div>

              {activeFilters.map((filter) => {
                const isExpanded = expandedFilters.includes(filter._id);
                return (
                  <div key={filter._id} className="filter-item">
                    <div
                      className="filter-header"
                      onClick={() => handleToggleFilter(filter._id)}
                    >
                      <span>{filter.displayName}:</span>
                      {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </div>

                    {isExpanded && (
                      <>
                        {filter.isRange && filter.range ? (
                          <div className="range-section">
                            <div className="range-header">
                              <label>
                                <input
                                  type="number"
                                  value={
                                    pendingRangeValues[filter._id]?.min ??
                                    filter.range.min
                                  }
                                  onChange={(e) =>
                                    handleTextPendingRangeChange(
                                      e,
                                      "min",
                                      filter._id,
                                      filter.range
                                    )
                                  }
                                />
                              </label>
                              <label>
                                <input
                                  type="number"
                                  value={
                                    pendingRangeValues[filter._id]?.max ??
                                    filter.range.max
                                  }
                                  onChange={(e) =>
                                    handleTextPendingRangeChange(
                                      e,
                                      "max",
                                      filter._id,
                                      filter.range
                                    )
                                  }
                                />
                              </label>
                            </div>

                            <div className="range-input-wrapper">
                              <input
                                type="range"
                                min={filter.range.min}
                                max={filter.range.max}
                                value={
                                  pendingRangeValues[filter._id]?.min ||
                                  filter.range.min
                                }
                                onChange={(e) =>
                                  handlePendingRangeChange(e, "min", filter._id)
                                }
                                className="range-input"
                              />
                              <input
                                type="range"
                                min={filter.range.min}
                                max={filter.range.max}
                                value={
                                  pendingRangeValues[filter._id]?.max ||
                                  filter.range.max
                                }
                                onChange={(e) =>
                                  handlePendingRangeChange(e, "max", filter._id)
                                }
                                className="range-input"
                              />
                              <div className="range-track-base"></div>
                              <div
                                className="range-track-active"
                                style={{
                                  left: `${
                                    Math.min(
                                      pendingRangeValues[filter._id]?.min ??
                                        filter.range.min,
                                      pendingRangeValues[filter._id]?.max ??
                                        filter.range.max
                                    ) /
                                    (filter.range.max / 100)
                                  }%`,
                                  width: `${
                                    ((Math.max(
                                      pendingRangeValues[filter._id]?.min ??
                                        filter.range.min,
                                      pendingRangeValues[filter._id]?.max ??
                                        filter.range.max
                                    ) -
                                      Math.min(
                                        pendingRangeValues[filter._id]?.min ??
                                          filter.range.min,
                                        pendingRangeValues[filter._id]?.max ??
                                          filter.range.max
                                      )) /
                                      (filter.range.max / 100)) *
                                    1
                                  }%`,
                                }}
                              ></div>
                            </div>

                            <button
                              className="accept"
                              onClick={() => applyRange(filter._id)}
                            >
                              Ок
                            </button>

                            <p className="range-hint">
                              *Фільтр за діапазоном набуде чинності після
                              натискання "OK".
                            </p>
                          </div>
                        ) : (
                          <div>
                            {filter.values?.map((valObj) => (
                              <label key={valObj._id} className="checkbox">
                                <input
                                  type="checkbox"
                                  name={filter._id}
                                  value={valObj._id}
                                  checked={
                                    selectedFilters[filter._id]?.includes(
                                      valObj._id
                                    ) || false
                                  }
                                  onChange={(e) =>
                                    handleCheckboxChange(e, filter._id)
                                  }
                                />
                                <span className="checkbox-custom"></span>
                                <span className="checkbox-label">
                                  {valObj.value}
                                </span>
                              </label>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default SsubListPage;
